import { useState, useEffect } from 'react';
import { ProSidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import { useDispatch, useSelector } from 'react-redux';
import { getSRolePermission } from '../userRolePermission/rolepermissionAction';
import { useParams, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import '../subproduct/testt.css';
import Footer from "./Footer";

import {FaArrowCircleRight,FaRupeeSign,FaCheck, FaBolt, FaCircle, FaCogs, FaGem , FaGgCircle, FaHeart , FaHelicopter ,FaIcicles,FaInfo, FaList, FaRegUser, FaSignOutAlt, FaUser, FaUserCog } from 'react-icons/fa' ;
import { FcDataConfiguration,FcManager, FcBullish, FcPackage} from 'react-icons/fc' ;

const iconMap = {
  FcBullish: <FcBullish/>,
  FcManager:<FcManager/>,
  FaArrowCircleRight:<FaArrowCircleRight/>,
  FcDataConfiguration:<FcDataConfiguration/>,
  FcPackage:<FcPackage/>,
  FaRupeeSign:<FaRupeeSign/>,
  FaCheck:<FaCheck/>
 
};

function Sidebar() {
  const [menuItems, setMenuItems] = useState([]);
  const [expandedMenuItems, setExpandedMenuItems] = useState([]);
  const [openDropdown, setOpenDropdown] = useState(null);
  const sidebarctx = useSelector((state)=>state.adminsidebar.isToggle);

  const roleid = localStorage.getItem("accessRoleId");
  const { permissionisLoading,combinedrolepermissiondetails } = useSelector(
    (state) => state.rolePermissionList
  );
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getSRolePermission(roleid));
  }, [roleid, dispatch]);

  useEffect(() => {
     const filteredMenuItems = combinedrolepermissiondetails.filter(item => item.menu_view === 1 && item.user_status === 1).sort((a, b) => a.sort - b.sort);
    setMenuItems(filteredMenuItems);
  }, [combinedrolepermissiondetails]);

  return (
    <>
    <ProSidebar collapsed={sidebarctx} width="250px" className="sidebar"   style={{
          position: 'sticky', // Set position to sticky
          top: '90px', // Adjust the value as needed based on your layout
          height: '100vh',
          overflowY: 'auto',
          // marginTop: '90px',
          zIndex: 1, // Add z-index if necessary to make sure the sidebar is above other elements
        }} toggled breakPoint='lg' bg="blue" variant="white" id="responsive-navbar-nav">

    {/* <ProSidebar collapsed={sidebarctx} width="250px" style={{ position: 'sticky', height: '100vh', overflowY: 'auto' ,marginTop:'90px'}}> */}
      <Menu iconShape="circle" popperArrow="true"  style={{color:'white'}}>
      {menuItems.map((item) => {
  if (item.parent_id === 0) {
    const subitems = menuItems.filter(subitem => subitem.parent_id === item.menu_id);
    if (subitems.length === 0) {
      return (
        <MenuItem key={item.id} icon={iconMap[item.icon]} style={{color:'white'}}>
          {item.label}
          <Link to={"/"+item.link}></Link>
        </MenuItem>
      );
    } else {
      return (
        <SubMenu key={item.id} title={item.label} icon={iconMap[item.icon]} active={expandedMenuItems.includes(item.id)} onMouseEnter={() => setOpenDropdown(item.label)}
        onMouseLeave={() => setOpenDropdown(null)}
        open={openDropdown === item.label}>
          {subitems.map((subitem) => (
            <MenuItem key={subitem.id} icon={iconMap[subitem.icon]}>
              {subitem.label}
              {subitem.link && <Link to={"/"+subitem.link}></Link>}
            </MenuItem>
          ))}
        </SubMenu>
      );
    }
  } else {
    return null;
  }
})}

      </Menu>
 
    </ProSidebar>
    
     </>
  );
}

export default Sidebar;